import type { FC } from 'react';
import FilterTag from './FilterTag';

export default FilterTag as FC<Record<string, unknown>>;
